import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useRef } from 'react';
import { memo } from 'react';
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const ContactsGroup = memo(({start, groupSelect, setNewGroup}) => {

    const [contacts, setContacts] = useState([]);
    const {showNotification} = useContext(NotificationContext);
    const [newContactGroup, setNewContactGroup] = useState(false);

    const btnClose = useRef();

    const getContacts = async() => {
      const result = await init();
      if(!result) return window.location.href = '/login'
      try {
        const URL = constants.test_host + '/user/group-contacts/' + groupSelect;
        const token= window.localStorage.getItem('at');
        const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
        setContacts(data.contacts);
        
      } catch (error) {
          showNotification('failed', error.response.data.message)
      }
    }

    const deleteContact = async(e) => {
      const result = await init();
      if(!result) return window.location.href = '/login'
      const URL = constants.test_host + '/user/delete-contacts/'+ groupSelect + '?id=' + e.target.offsetParent.id;
      const token= window.localStorage.getItem('at');
      const {data} = await axios.delete(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      setNewContactGroup(!newContactGroup);
      setNewGroup(!newContactGroup);
      showNotification('success', 'Contacto eliminado del grupo.');
    }


    const tableContacts = contacts.map((item, index) =>
  
        <tr key={item.idClient._id}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'justify'}}>{item.idClient.name}</td>
        <td style={{textAlign: 'justify'}}>{item.idClient.lastname}</td>
        <td style={{textAlign: 'justify'}}>{item.idClient.celphone}</td>
        <td id={item.idClient._id} style={{textAlign: 'justify'}}><a title='Eliminar del grupo' className='btn-sm btn btn-primary' onClick={(e) => deleteContact(e)}><i className="fas fa-trash-alt"></i></a></td>
        </tr>
    )

    useEffect(()=> {
      if(!start) getContacts();
    },[start, groupSelect, newContactGroup])

  return (
    <>
          <div className=' container modal-header'>
                  
            <div className='modal-title'>
              <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '7%'}} src="/SMS-APP.png" />
              <h2 style={{fontSize: '20px'}} className="font-weight-bold text-white"> SMS APP</h2>
              <button ref={btnClose}  style={{backgroundColor: 'white'}} type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
          </div>
          <div className='modal-body text-center text-color'>
            <h6 className="text-color mb-4" style={{fontSize: '13px'}}>
              Grupo: {groupSelect}
            </h6>
            
            <div>
                <div>
                <h6 style={{textAlign: 'left', paddingLeft:'20px', fontSize:'smaller'}}>Contactos en el grupo:</h6>
                <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
                    <thead>
                        <tr>
                        <th>#Id</th>
                        <th>Nombre</th>
                        <th>Apellido</th>
                        <th>Celular</th>
                        <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableContacts}
                    </tbody>
                </table>
                </div>
            </div>
              
          </div>

          <div className='modal-footer text-center'>
            <br />
            <button className='btn btn-sm btn-primary' onClick={()=> btnClose.current.click()}>Cerrar</button>
          </div>
        </>
  )
})

export default ContactsGroup
